import React, { useEffect, useState } from "react";
import "./style.css";
import { CreateTeacher, EditTeacher } from "./Modals";
import api from "../../utilis/api";
import { toast } from "react-toastify";
import { url } from "../../utilis/contant";

const Teacher = () => {
  const [teachers, setTeachers] = useState([]);
  const [modalTeacher, setModalTeacher] = useState(null);
  const [search, setSearch] = useState("");
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const getTeachers = async () => {
    try {
      const response = await api.get("/user?role=teacher");
      // Assuming response.data.data contains the array of teachers
      setTeachers(response.data.data);
      console.log(response.data.data);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };

  useEffect(() => {
    getTeachers();
  }, [isEditModalOpen]);
  const handleActive = async (id, status) => {
    try {
      const res = await api.put(
        `/user/${id}`,
        {
          accountverified: !status,
        },
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      if (res) {
        toast.success("Teacher Updated Successfully");
        getTeachers();
      }
    } catch (error) {
      toast.error("Status Not Updated");
    }
  };
  const handleDelete = async (id) => {
    try {
      const res = await api.delete(`/user/${id}`, {
        headers: { "Content-Type": "application/json" },
      });

      if (res) {
        toast.success("Teacher Deleted Successfully");
        getTeachers();
      }
    } catch (error) {
      toast.error("Teacher Not Deleted");
    }
  };
  const filteredteachers = teachers?.filter((s) =>
    `${s.name} ${s.email} ${s.phone}`
      .toLowerCase()
      .includes(search.toLowerCase()),
  );
  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    return names
      .map((n) => n[0]?.toUpperCase())
      .join("")
      .slice(0, 2); // Max 2 letters
  };
  return (
    <div className="overview-container">
      <header className="overview-header ">
        <div className="header-text bg-black">
          <span className=" header-subtitle">Welcome Back, Robert</span>
          <h1 className="header-title">All Teachers</h1>
        </div>
        {/* */}
        <button className="add-btn" onClick={() => setIsCreateModalOpen(true)}>
          New Teacher
        </button>
      </header>
      {/* SEARCH BAR */}
      <div className="search-box">
        <input
          type="text"
          placeholder="Search by name, email, phone..."
          value={search}
          disabled={isCreateModalOpen || isEditModalOpen}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* TABLE */}
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredteachers?.length > 0 ? (
              filteredteachers?.map((teacher) => (
                <tr key={teacher._id}>
                  <td>
                    {teacher.image ? (
                      <img
                        src={`${url}/${teacher.image}`}
                        alt={teacher.name}
                        className="teacher-avatar"
                      />
                    ) : (
                      <div className="teacher-avatar avatar-fallback">
                        {getInitials(teacher.name)}
                      </div>
                    )}
                  </td>
                  <td>{teacher.name}</td>
                  <td>{teacher.email}</td>
                  <td>{teacher.phone}</td>

                  {/* TOGGLE */}
                  <td>
                    <td>
                      <span
                        onClick={() =>
                          handleActive(teacher._id, teacher.accountverified)
                        }
                        className={`status-btn ${
                          teacher.accountverified ? "active" : "blocked"
                        }`}
                      >
                        {teacher.accountverified ? "Active" : "Not Active"}
                      </span>
                    </td>
                  </td>

                  {/* ACTIONS */}
                  <td>
                    <button
                      className="edit-btn"
                      onClick={() => {
                        setIsEditModalOpen(true);
                        setModalTeacher(teacher);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(teacher._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="no-data">
                  No teachers found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isCreateModalOpen && (
        <CreateTeacher onClose={() => setIsCreateModalOpen(false)} />
      )}
      {isEditModalOpen && (
        <EditTeacher
          onClose={() => setIsEditModalOpen(false)}
          teacher={modalTeacher}
        />
      )}
    </div>
  );
};

export default Teacher;
